/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Targetservice1Inputs */

const en_entity_targetservice1 = /** @type {(inputs: Entity_Targetservice1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Target Service`)
};

const de_entity_targetservice1 = /** @type {(inputs: Entity_Targetservice1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zieldienst`)
};

/**
* | output |
* | --- |
* | "Target Service" |
*
* @param {Entity_Targetservice1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_targetservice1 = /** @type {((inputs?: Entity_Targetservice1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Targetservice1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_targetservice1(inputs)
	return de_entity_targetservice1(inputs)
});
export { entity_targetservice1 as "entity_targetService" }